module.exports = __webpack_public_path__ + "static/img/top3.18178e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/top3.png
// module id = B399
// module chunks = 23